<template>
  <div class="bt-card">
    <el-card v-for="cardItem in cardData" :key="cardItem._id">
      <div>
        {{ cardItem.category }} <el-tag :type="getType(cardItem)" size="mini">{{ getWord(cardItem) }}</el-tag>
      </div>
      <div style="color:#999">{{ cardItem.time }}</div>
      <div style="text-align:right">
        <el-button type="text" size="mini" @click="showEdit(cardItem)">修改</el-button>
        <el-button type="text" size="mini" @click="clean(cardItem)">清除</el-button>
      </div>
    </el-card>
    <el-dialog title="修改离职意愿度" :modal="false" :close-on-click-modal="false" :visible.sync="isEditShow" width="200px">
      <el-select v-model="editingPercent" size="mini">
        <el-option label="强" :value="95"></el-option>
        <el-option label="中" :value="75"></el-option>
        <el-option label="弱" :value="55"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="isEditShow = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="edit">确 定</div>
        <!-- <el-button size="mini" @click="isEditShow = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="edit">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    company: {
      type: String,
    },
  },
  data() {
    return {
      cardData: [],
      editingItem: {},
      editingPercent: 0,
      isEditShow: false,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const res = await app.service('misc').listLeaveForecast({ company: this.company })
      if (res.status === 'success') {
        this.cardData = res.data
      }
    },
    getWord(cardItem) {
      if (cardItem.percent > 80) {
        return '强'
      } else if (cardItem.percent > 60) {
        return '中'
      } else {
        return '弱'
      }
    },
    getType(cardItem) {
      if (cardItem.percent > 80) {
        return 'danger'
      } else if (cardItem.percent > 60) {
        return 'warning'
      } else {
        return 'info'
      }
    },
    showEdit(cardItem) {
      this.editingItem = cardItem
      this.editingPercent = cardItem.percent
      this.isEditShow = true
    },
    async edit() {
      if (this.editingItem.percent === this.editingPercent) {
        this.isEditShow = false
        return false
      }
      const res = await app.service('misc').updateYiyuandu({
        company: this.editingItem.company,
        category: this.editingItem.category,
        percent: this.editingPercent,
        from: 'custom',
        time: dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss'),
      })
      if (res.status === 'success') {
        this.$message.success('修改成功')
        this.cardData = this.cardData.map(item => {
          if (item._id === this.editingItem._id) {
            item.percent = this.editingPercent
          }
          return item
        })
        this.isEditShow = false
      }
    },
    clean(cardItem) {
      this.$confirm(
        `确定清除【${cardItem.company}】公司【${cardItem.category}】职能模块及相关人选的 离职意愿度吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(async () => {
          const res = await app.service('misc').updateYiyuandu({
            company: cardItem.company,
            category: cardItem.category,
            percent: 0,
            from: 'custom',
            time: dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss'),
          })
          if (res.status === 'success') {
            this.$message.success('清除成功')
            this.cardData = this.cardData.filter(item => item._id !== cardItem._id)
          }
        })
        .catch(() => {})
    },
  },
}
</script>
<style>
.bt-card {
  display: flex;
  flex-wrap: wrap;
}
.bt-card .el-card__body {
  padding: 10px 10px 3px 10px;
}
</style>
